import { useNavigate } from 'react-router-dom';
import { Box, Button, Stack, Typography } from '@mui/material';
import routes from '@/constants/routes';

const CreatedAccount = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 4,
        gap: 2,
      }}
    >
      <Stack gap={2} alignItems={'center'}>
        <Typography variant="h1">¡Tu cuenta ha sido creada!</Typography>
        <Typography variant="body1" color="GrayText">
          Antes de iniciar sesión revisa tu cuenta de correo asociada para
          activar tu cuenta
        </Typography>
      </Stack>
      <Button
        size="large"
        variant="contained"
        onClick={() => navigate(routes.login)}
      >
        Iniciar Sesión
      </Button>
      <Button
        size="large"
        variant="outlined"
        onClick={() => navigate(routes.signUp)}
      >
        Crea otra cuenta
      </Button>
    </Box>
  );
};

export default CreatedAccount;
